import { FormHTMLAttributes } from 'react';
import { useForm } from 'react-hook-form';

import { ErrorMessage } from '@hookform/error-message';
import { Colors } from 'enums/colors';

import Button from '../Button/Button';
import QuestionFormInput from '../QuestionFormInput/QuestionFormInput';

export interface VehicleEnquireFormProps
  extends Omit<FormHTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  onSubmit(value: any): any;
  loading?: boolean;
}

const VehicleEnquireForm = ({
  onSubmit,
  loading,
  ...props
}: VehicleEnquireFormProps) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const ErrorBox = <p className="text-coral-80" />;

  return (
    <form {...props} onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-2">
        <label htmlFor="first_name" className="text-sm text-grey-80">
          First name
        </label>
        <QuestionFormInput
          {...register('first_name', { required: 'This field is required' })}
          id="first_name"
        />
        <ErrorMessage errors={errors} name="first_name" as={ErrorBox} />
      </div>
      <div className="mb-2">
        <label htmlFor="last_name" className="text-sm text-grey-80">
          Last name
        </label>
        <QuestionFormInput
          {...register('last_name', { required: 'This field is required' })}
          id="last_name"
        />
        <ErrorMessage errors={errors} name="last_name" as={ErrorBox} />
      </div>
      <div className="mb-2">
        <label htmlFor="email" className="text-sm text-grey-80">
          Email address
        </label>
        <QuestionFormInput
          type="email"
          id="email"
          {...register('email', { required: 'This field is required' })}
        />
        <ErrorMessage errors={errors} name="email" as={ErrorBox} />
      </div>
      <div className="mb-2">
        <label htmlFor="phone" className="text-sm text-grey-80">
          Phone number
        </label>
        <QuestionFormInput
          id="phone"
          {...register('phone', {
            required: 'This field is required',
            pattern: {
              value:
                /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/,
              message: 'This field must be an Australian number',
            },
          })}
        />
        <ErrorMessage errors={errors} name="phone" as={ErrorBox} />
      </div>
      <label className="flex items-center justify-center mb-4 md:justify-start">
        <input
          className="mr-3"
          type="checkbox"
          {...register('blinker_checkbox')}
        />
        <span>
          I agree to the Loopit Privacy Policy and that I am over 21 years of
          age.
        </span>
      </label>
      <div className="flex items-center justify-between">
        <p className="m-0 flex items-center">
          <span className="mr-3">Powered by</span>
          <img src="/images/loopit_logo.webp" alt="loopit" width={60} />
        </p>
        <Button
          className="px-10"
          color={Colors.green}
          type="submit"
          disabled={loading}
        >
          SUBSCRIBE
        </Button>
      </div>
    </form>
  );
};

export default VehicleEnquireForm;
